import { Carousel, Checkbox, Collapse, InputNumber, Popover } from 'antd'
import * as React from 'react'

import { useNodeMutation } from '@hooks'
import { Switch } from '@ui-pc'
import { Processor } from '@utils/tool'

import styles from './index.module.scss'

interface FilterSortProps {
  initData?: any
  filterForm?: any
  data: any[]
  handleChange: Function
  isSearch?: boolean // 搜索页
}

const FilterSort: React.FunctionComponent<FilterSortProps> = (props) => {
  const filterList: any[] = props.data || []
  const handleChange = props.handleChange
  const params = props.filterForm
  const [priceError, setPriceError] = React.useState(false)
  const [minValue, setMinValue]: any = React.useState('')
  const [maxValue, setMaxValue]: any = React.useState('')
  const debounSearch = React.useMemo(() => Processor.timeout(), [])

  // 选择属性
  // const onSelectAttr = (value: number | string) => {
  //   React.startTransition(() => {
  //     let ids = params.filterValueIds?.split(',') || []
  //     if (ids.indexOf(value) === -1) {
  //       ids.push(value)
  //     } else {
  //       ids.splice(ids.indexOf(value), 1)
  //     }
  //     handleChange({
  //       filterValueIds: ids.filter((el: string) => el !== '').join(',')
  //     })
  //   })
  // }

  // const handleDefaultChecked = (value?: string): boolean => {
  //   const ids = params.filterValueIds?.split(',') || []
  //   if (ids?.includes(value)) {
  //     return true
  //   }
  //   return false
  // }

  // 选择属性
  const onSelectAttr = (value: number | string, paramKey?: string) => {
    React.startTransition(() => {
      let ids = params[paramKey]?.split(',') || []
      if (ids.indexOf(value) === -1) {
        ids.push(value)
      } else {
        ids.splice(ids.indexOf(value), 1)
      }
      handleChange({
        [paramKey]: ids.filter((el: string) => el !== '').join(',')
      })
    })
  }

  const handleDefaultChecked = (value?: string, paramKey?: string): boolean => {
    const ids = params[paramKey]?.split(',') || []
    if (ids?.includes(value)) {
      return true
    }
    return false
  }

  // 价格处理
  const handlePrice = (type: string, value: string | number) => {
    let obj: any = {}
    const newMax: any = +props.initData.maxPrice

    if (type === 'min') {
      obj.minPrice = value ? value : ''
      setMinValue(value)
    } else {
      obj.maxPrice = value > newMax ? newMax : value ? value : ''
      setMaxValue(value)
    }

    if (
      +value > newMax ||
      (type === 'min' && maxValue && +value > Number(maxValue)) ||
      (type !== 'min' && minValue && +value < Number(minValue))
    ) {
      setPriceError(true)
    } else {
      setPriceError(false)
      debounSearch(() => handleChange(obj), 500)
    }
  }

  React.useEffect(() => {
    React.startTransition(() => {
      const min = props.filterForm.minPrice
      const max = props.filterForm.maxPrice
      setMinValue(min)
      setMaxValue(max)
      if (+min > +props.initData.maxPrice) {
        setPriceError(true)
      }
    })
  }, [props.filterForm])

  const priceRef = React.useRef()
  const priceRangeNode = () => {
    return (
      <div
        className={`${styles['filter-item']} ${styles['filter-item-price']}`}
        ref={priceRef}
        style={{ marginTop: 0 }}
      >
        <div className={styles['price-range-box']}>
          <span>Price</span>
          <div className={styles['price-range']}>
            <InputNumber
              className={styles['input-area']}
              placeholder='min'
              min={0}
              value={minValue}
              onChange={(value) => handlePrice('min', value)}
            />
            <span className={styles['input-line']}></span>
            <InputNumber
              className={styles['input-area']}
              placeholder='max'
              max={+props.initData.maxPrice}
              value={maxValue}
              onChange={(value) => handlePrice('max', value)}
            />
          </div>
        </div>
        {priceError ? (
          <div className={styles['error-tips']}>{`Value must be between ${
            minValue && minValue < +props.initData?.maxPrice ? minValue : 0
          } and ${+props.initData?.maxPrice}`}</div>
        ) : null}
      </div>
    )
  }

  const attrNode: React.FC = (options: any[]) => (
    <div className={styles['attributes-checkbox-group']}>
      {options.map((o) => {
        const paramKey =
          o.productsOptionsId == 'c' ? 'filterCat' : 'filterValueIds'
        const keyId = o.value + ''
        return (
          <Checkbox
            checked={handleDefaultChecked(keyId, paramKey)}
            key={o.productsOptionsValuesId}
            onChange={() => onSelectAttr(keyId, paramKey)}
          >
            {o.productsOptionsValuesName}
          </Checkbox>
        )
      })}
    </div>
  )
  const [currentIndex, setCurrentIndex] = React.useState(0)
  const [widthLimit, setWidthLimit] = React.useState([])
  const [showArrow, setShowArrow] = React.useState(false)
  const carouselRef: any = React.useRef()

  const slidePrev = () => {
    carouselRef.current?.prev()
  }

  const slideNext = () => {
    carouselRef.current?.next()
  }

  const ref: any = useNodeMutation(() => {
    recordWidth()
  })

  // 计算item的宽度
  const recordWidth = () => {
    const parent: any = document.getElementById('sliderFilter')
    const childs = [...parent?.querySelectorAll(`.${styles['filter-item']}`)]
    let arr = []
    childs?.map((item: any) => {
      arr.push(item.clientWidth)
    })
    const sum = arr.reduce(function (prev, cur) {
      return prev + cur
    }, 0)

    setWidthLimit(sum)
  }

  React.useEffect(() => {
    const parent: any = document.getElementById('sliderFilter')
    const parentW = parent.clientWidth
    setShowArrow(!!(widthLimit > parentW))
  }, [widthLimit])

  // 左侧栏展示/顶部固定几个展示---共用: flash category区域
  const cateFlashAttrNode: React.FC = (options: any[]) => (
    <div className={styles['flash-cate-group']}>
      <Collapse
        className={styles['category-collapse']}
        ghost={true}
        expandIconPosition={'end'}
        expandIcon={({ isActive }) => (
          <i
            className={`iconfont ${
              isActive ? 'icon-pc_-new' : 'icon-a-pc_add-new'
            }`}
          />
        )}
        items={options?.map((k, ki) => {
          const paramKey = 'filterCat'
          return {
            key: ki,
            label: <span>{k.label}</span>,
            children: (
              <div className={styles['attributes-checkbox-group']}>
                {k.children?.map((child) => {
                  const keyId = child.id + ''
                  return (
                    <Checkbox
                      checked={handleDefaultChecked(keyId, paramKey)}
                      key={child.id}
                      onChange={() => onSelectAttr(keyId, paramKey)}
                    >
                      {child.categoriesName}
                    </Checkbox>
                  )
                })}
              </div>
            )
          }
        })}
      />
    </div>
  )

  return (
    <div className={styles['slider-filter-box']}>
      <Switch either={!!filterList?.length}>
        <>
          <div
            className={styles['slider-list-wrap']}
            id='sliderFilter'
            ref={(el) => {
              ref.current.el = el
            }}
          >
            <Carousel
              dots={false}
              afterChange={setCurrentIndex}
              autoplay={false}
              slidesToScroll={1}
              variableWidth
              arrows={true}
              infinite={false}
              ref={carouselRef}
            >
              {filterList?.map((k: any, index: number) => {
                const options = (k.productsOptionValuesList || [])?.map(
                  (attr: any) => {
                    const obj = {
                      label: attr.productsOptionsValuesName,
                      value: attr.productsOptionsValuesId + '',
                      ...attr
                    }
                    return obj
                  }
                )
                // ?.filter((attr) => attr.productsOptionsId !== 'p')

                return (
                  <div className={styles['filter-item']} key={index}>
                    <Popover
                      placement='bottomLeft'
                      title={null}
                      //content={attrNode(k.productsOptionValuesList)}
                      content={
                        k.productsOptionsId === 's'
                          ? cateFlashAttrNode(options)
                          : attrNode(options)
                      }
                      arrow={false}
                      overlayClassName={styles['filter-popover']}
                      trigger='hover'
                    >
                      <div className={styles['filter-item-label']}>
                        {k.productsOptionsName}{' '}
                        <i className='iconfont icon-m_ic_xiala'></i>
                      </div>
                    </Popover>
                  </div>
                )
              })}
              {priceRangeNode()}
            </Carousel>
          </div>
          <div
            className={styles['slider-arrow']}
            style={{ opacity: showArrow ? '1' : '0' }}
          >
            <i
              className={`iconfont icon-left ${
                currentIndex === 0 && styles['disabled-icon']
              }`}
              onClick={slidePrev}
            ></i>
            <i className='iconfont icon-right' onClick={slideNext}></i>
          </div>
        </>
      </Switch>
    </div>
  )
}

export default FilterSort
